import React from 'react';
import { IconProps } from '../types/Icon';

export default function EmailIcon({ height = 16, width = 15, colour = '#FFFFFF' }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 15 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M13.4375 11.75L9.28571 8M5.71429 8L1.56252 11.75M1.25 4.875L6.35307 8.44715C6.76631 8.73641 6.97292 8.88105 7.19766 8.93707C7.39618 8.98655 7.60382 8.98655 7.80233 8.93707C8.02708 8.88105 8.23369 8.73641 8.64692 8.44715L13.75 4.875M4.25 13H10.75C11.8001 13 12.3251 13 12.7262 12.7956C13.079 12.6159 13.3659 12.329 13.5456 11.9762C13.75 11.5751 13.75 11.0501 13.75 10V6C13.75 4.9499 13.75 4.42485 13.5456 4.02377C13.3659 3.67096 13.079 3.38413 12.7262 3.20436C12.3251 3 11.8001 3 10.75 3H4.25C3.1999 3 2.67485 3 2.27377 3.20436C1.92096 3.38413 1.63413 3.67096 1.45436 4.02377C1.25 4.42485 1.25 4.9499 1.25 6V10C1.25 11.0501 1.25 11.5751 1.45436 11.9762C1.63413 12.329 1.92096 12.6159 2.27377 12.7956C2.67485 13 3.1999 13 4.25 13Z"
                stroke={colour}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
